export type IconKind = 'ICON_BELL' | 'ICON_WALLET'; /** card */

export type OpenFlag = 'ALL' | 'OPENED' | 'NOT_OPENED';

export interface ClinicNotificationHistoryInput {
  openFlag: OpenFlag;
  pagination: Pagination;
}

export interface ClinicNotificationHistoryDto {
  readonly id: Id;
  readonly testHistoryId: Id;
  readonly title: string;
  readonly isAlreadyOpened: boolean;
  readonly iconKind: IconKind;
  readonly createdAt: DateString;
  readonly testName: Name;
  readonly testSerial: Serial;
  readonly clinicName: Name;
}

export interface NotificationHistory {
  readonly id: Id;
  readonly testHistoryId: Id;
  readonly title: string;
  readonly isAlreadyOpened: boolean;
  readonly iconKind: IconKind;
  readonly createdAt: Date;
  readonly testName: Name;
  readonly testSerial: Serial;
  readonly clinicName: Name;
}

export const notificationFromDto = (val: ClinicNotificationHistoryDto) => {
  return { ...val, createdAt: new Date(val.createdAt) };
};
